import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { onMounted, watch, ref, computed } from 'vue';

import { onUnmounted } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'XPixel',
  props: {
  xPixelId: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;

const isXPixelInitialized = ref(false);
const consentGiven = ref(false); // Track consent state

// Check consent from URL parameters or internal state
const hasConsent = computed(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const trackingOptIn = urlParams.get('trackingOptIn');
  
  // If we're in WebView context (trackingOptIn parameter exists)
  if (trackingOptIn !== null) {
    return trackingOptIn === 'true';
  }
  
  // If we're on standalone webpage, use internal consent state
  return consentGiven.value;
});

// Initialize X Ads pixel
const initializeXAds = (id: string) => {
  if (!id || !hasConsent.value || isXPixelInitialized.value) return;
  // Clear any existing pixels
  (window as any).twq = undefined;
  
  // Initialize new pixel with the ID
  // @ts-ignore
  !function(e: any, t: any, n: any, s: any, u: any, a: any) {
    e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))
  }(window,document,'script');
  
  // Initialize with the account ID
  (window as any).twq('init', id);
  (window as any).twq('track', 'PageView');
  
  isXPixelInitialized.value = true;
};

// Revoke X Pixel consent and clear
const revokeXPixelConsent = () => {
  if ((window as any).twq && isXPixelInitialized.value) {
    // Clear the twq function
    delete (window as any).twq;
    // Remove any X pixel scripts
    const scripts = document.querySelectorAll('script[src*="ads-twitter.com"]');
    scripts.forEach(script => script.remove());
    isXPixelInitialized.value = false;
  }
};

// Handle consent changes
const handleConsentChange = () => {
  if (hasConsent.value && props.xPixelId) {
    initializeXAds(props.xPixelId);
  } else {
    revokeXPixelConsent();
  }
};

// Initialize when component mounts
onMounted(() => {
  window.addEventListener('message', handleConsentMessage);
  handleConsentChange();
  if(!window.ReactNativeWebView) {
    // If not in WebView, check local storage
    consentGiven.value = localStorage.getItem('trackingOptIn') === 'true';
  }
});

// Watch for pixel ID changes
watch(() => props.xPixelId, (newId) => {
  if (newId && hasConsent.value) {
    // Reset initialization flag when pixel ID changes
    isXPixelInitialized.value = false;
    initializeXAds(newId);
  }
});

// Watch for consent changes
watch(hasConsent, () => {
  handleConsentChange();
});

// Listen for consent updates (from banner or React Native)
const handleConsentMessage = (event: MessageEvent) => {
  if (event.data && typeof event.data === 'string') {
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'CONSENT_UPDATED') {
        // Update internal consent state for standalone webpage
        consentGiven.value = data.payload.action === 'accept';
      }
    } catch (e) {
      // Ignore non-JSON messages
    }
  }
};

// Cleanup
onUnmounted(() => {
  window.removeEventListener('message', handleConsentMessage);
});

return (_ctx: any,_cache: any) => {
  return (__props.xPixelId && hasConsent.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})